// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"VehicleSpecsDetailsButton_loadingSpinner__LkRFx","detailsLink":"VehicleSpecsDetailsButton_detailsLink__OEYrz"};